var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 34,
    viewBox: "0 0 27 34",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 17.9485L5.18756 13.5729L14.5074 24.6222L15.5 31.5L9.31986 28.9978L0 17.9485Z",
    fill: "#CE838E"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20.662,
    width: 6.7865,
    height: 31.2179,
    transform: "rotate(20.9477 20.662 0)",
    fill: "#CE838E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/Check.e72bfed13ee31bcd736996c620277723.svg";
export { ForwardRef as ReactComponent };